import { Typography } from '@mui/material';
import axios from 'axios';
import { history } from 'ice';
import React, { useEffect } from 'react';
import useSWR from 'swr';

import MainButton from '@/components/UI/mobile/MainButton';
import commonhelper from '@/lib/commonhelper';
import client from '@/lib/feathers';
import generateBarcodeDataUrl from '@/utils/generateBarcodeDataUrl';

import styles from './index.module.scss';

const userFetcher = () => client.reAuthenticate().then((data) => data.user);

function brightestUpdate() {
  if (commonhelper.isApp()) {
    history.location.pathname === `/mobile/setting` &&
      commonhelper
        .brightest()
        .then((res) => {
          console.log('====brightest success', res);
        })
        .catch((error) => {
          console.log('====brightest fail', error);
        });
  }
}

function getImageFrom(src: string) {
  return new Promise<string>((resolve, reject) => {
    axios
      .get(src, { responseType: 'blob' })
      .then((res) => {
        const imgUrl = URL.createObjectURL(res.data);
        resolve(imgUrl);
      })
      .catch(() => reject);
  });
}

function MobileSetting() {
  const { data: user } = useSWR('user', userFetcher);
  const { data: currentUserImgSrc } = useSWR<string>(user?.img, getImageFrom);

  let currentUserName = '';
  let currentUserEmail = '';
  let currentUserBarcodeType = '';
  let usersHouseholdNumbers = '';
  let NOT_WALL_DEVICE = false;

  if (user) {
    currentUserName = user?.name || '';
    currentUserEmail = user?.email || '';
    currentUserBarcodeType = user?.barcodeType || '';
    usersHouseholdNumbers =
      !Object.prototype.hasOwnProperty.call(user, 'householdNumbers') ||
      user.householdNumbers.length === 0
        ? false
        : user.householdNumbers;
    NOT_WALL_DEVICE = Boolean(!user?.keyboardAccount);
  }

  // useEffect(() => {
  //   // brightestUpdate();
  // }, []);

  return (
    <div className={styles.container}>
      <div className={styles.contents}>
        <div className={styles.infos}>
          <div className={styles.avatar}>
            <img src={currentUserImgSrc || 'icon/ic_photo.svg'} alt="avatar" />
          </div>
          <div className={styles.info}>
            <Typography className={styles.infoTitle}>暱稱</Typography>
            <Typography className={styles.infoContent}>
              {currentUserName}
            </Typography>
          </div>
          <div className={styles.info}>
            <Typography className={styles.infoTitle}>帳號</Typography>
            <Typography className={styles.infoContent}>
              {currentUserEmail}
            </Typography>
          </div>
          <div className={styles.info}>
            <Typography className={styles.infoTitle}>戶號</Typography>
            <Typography className={styles.infoContent}>
              {usersHouseholdNumbers}
            </Typography>
          </div>
        </div>
        {NOT_WALL_DEVICE && (
          <div className={styles.barcode}>
            <img
              src={generateBarcodeDataUrl(currentUserBarcodeType, {
                width: 3,
                height: 150,
                fontSize: 40,
                background: 'transparent',
              })}
              alt="barcode"
            />
          </div>
        )}
      </div>
      <MainButton
        disableRipple
        className={styles.editButton}
        onClick={() => {
          history.push('/mobile/user/person');
        }}
      >
        修改設定
      </MainButton>
    </div>
  );
}

export default MobileSetting;
